// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".present-as-tags[data-v-6f3c067e] {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n.present-as-tags .tag[data-v-6f3c067e] {\n  font-size: 0.6rem !important;\n}", ""]);
// Exports
module.exports = exports;
